exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-index-tsx": () => import("./../../../src/templates/index.tsx" /* webpackChunkName: "component---src-templates-index-tsx" */),
  "slice---src-components-slices-footer-index-tsx": () => import("./../../../src/_components/slices/footer/index.tsx" /* webpackChunkName: "slice---src-components-slices-footer-index-tsx" */),
  "slice---src-components-slices-header-index-tsx": () => import("./../../../src/_components/slices/header/index.tsx" /* webpackChunkName: "slice---src-components-slices-header-index-tsx" */)
}

